import { createContext } from "react";
import { IOnlineStatusProvider } from "./OnlineStatusInterfaces";

export const initialState: IOnlineStatusProvider = {
    updateOnlineStatus: () => Promise.resolve(false),
    onlineStatus: false,
};

export const OnlineStatusContext = createContext(initialState);
